import React from "react";

const XFactor = () => {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#a3d9b5", // Lighter green shade
                color: "#333", // Darker text color for better contrast
                padding: "50px",
                borderRadius: "15px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                margin: "50px 0",
            }}
        >
            {/* Content Section */}
            <div style={{ flex: 1, paddingRight: "20px" }}>
                <h2
                    style={{
                        fontSize: "36px",
                        fontWeight: "bold",
                        color: "#2c3e50", // Darker shade for the heading
                        marginBottom: "20px",
                    }}
                >
                    Our X Factor
                </h2>
                <p
                    style={{
                        fontSize: "18px",
                        lineHeight: "1.8",
                        color: "#2c3e50", // Darker shade for the paragraph
                    }}
                >
                    At Scented Ethos, we pride ourselves on delivering end-to-end solutions, from printing to perfume manufacturing, for all types of hanging car air fresheners. But we don't stop there—our vision goes beyond boundaries. For instance, our innovative designs feature transparent, breathable chambers that not only showcase the remaining liquid but also enhance the product's aesthetic appeal. Paired with captivating fragrances, these uniquely placed chambers redefine elegance and functionality, setting a new standard in the world of air fresheners.
                </p>
            </div>

            {/* Image Section */}
            <div style={{ flex: 1, textAlign: "center" }}>
                <img
                    src="unique_image.jpeg" // Replace with your image path
                    alt="X Factor"
                    style={{
                        width: "100%",
                        maxWidth: "400px",
                        borderRadius: "15px",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                    }}
                />
            </div>
        </div>
    );
};

export default XFactor;
